import React, { useState , useEffect } from "react";
import axios from "axios";
import Lottie from "lottie-react";
import loadingAnimation from "../../Assets/animations/loading.json";
import "./TrainingForm.css";
import { useNavigate } from 'react-router-dom';

const courseOptions = {
  Frontend: ["React", "Angular", "Vue", "Svelte"],
  Backend: ["Spring Boot", "Node.js", "Django", "Laravel"],
  "Full Stack": ["MERN", "MEAN", "Java + React", "Python + Angular"],
  Cloud: ["AWS", "Azure", "Google Cloud", "DevOps"],
};

const TrainingForm = () => {
  const [phone, setPhone] = useState("");
  const [trainingType, setTrainingType] = useState("");
  const [courseType, setCourseType] = useState("");
  const [technology, setTechnology] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const userId = localStorage.getItem('userId');
const navigate = useNavigate();

      useEffect(() => {
          if (!userId) {
              navigate('/login');
              return;
          }
      });

  const validate = () => {
    const newErrors = {};
    if (!phone) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(phone)) {
      newErrors.phone = "Phone number must be 10 digits";
    }
    if (!trainingType) {
      newErrors.trainingType = "Please select training type";
    }
    if (!courseType) {
      newErrors.courseType = "Please select a course type";
    }
    if (!technology) {
      newErrors.technology = "Please select a technology";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (validate()) {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        "https://api.skillzverse.com/COURSEMANAGEMENTSERVICE/api/v1/training/register",
        {
          name: localStorage.getItem("fullName"),
          email: localStorage.getItem("email"),
          phone,
          trainingType,
          courseType,
          technology,
        }
      );

      setMessage(response.data);

      setPhone("");
      setTrainingType("");
      setCourseType("");
      setTechnology("");
      setErrors({});
    } catch (error) {
      setMessage("Error submitting registration. Please try again.");
    } finally {
      setLoading(false);
    }
  }
};

  return (
    <form className="form-containerr" onSubmit={handleSubmit}>
      <h2>Training Registration</h2>

      {/* Phone Number */}
      <div className="form-groupp">
        <label>Phone Number:</label>
        <input
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Enter 10-digit phone number"
        />
        {errors.phone && <p className="error">{errors.phone}</p>}
      </div>

      {/* Training Type */}
      <div className="form-groupp">
        <label>Training Type:</label>
        <div className="radio-groupp">
          <label>
            <input
              type="radio"
              value="Online"
              checked={trainingType === "Online"}
              onChange={(e) => setTrainingType(e.target.value)}
            />
            Online
          </label>
          <label>
            <input
              type="radio"
              value="Offline"
              checked={trainingType === "Offline"}
              onChange={(e) => setTrainingType(e.target.value)}
            />
            Offline
          </label>
        </div>
        {errors.trainingType && <p className="error">{errors.trainingType}</p>}
      </div>

      {/* Course Type */}
      <div className="form-groupp">
        <label>Course Type:</label>
        <select
          value={courseType}
          onChange={(e) => {
            setCourseType(e.target.value);
            setTechnology("");
          }}
        >
          <option value="">-- Select Course --</option>
          {Object.keys(courseOptions).map((course) => (
            <option key={course} value={course}>
              {course}
            </option>
          ))}
        </select>
        {errors.courseType && <p className="error">{errors.courseType}</p>}
      </div>

      {/* Technology */}
      {courseType && (
        <div className="form-groupp">
          <label>Technology:</label>
          <select
            value={technology}
            onChange={(e) => setTechnology(e.target.value)}
          >
            <option value="">-- Select Technology --</option>
            {courseOptions[courseType].map((tech) => (
              <option key={tech} value={tech}>
                {tech}
              </option>
            ))}
          </select>
          {errors.technology && <p className="error">{errors.technology}</p>}
        </div>
      )}

      {/* Submit Button / Loader */}
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Lottie animationData={loadingAnimation} loop={true} style={{ height: 80 }} />
          <p>Submitting...</p>
        </div>
      ) : (
        <button type="submit" className="submit-btnn">
          Submit
        </button>
      )}

      {/* Response Message */}
      {message && <p style={{ marginTop: "15px", color: "green" }}>{message}</p>}
    </form>
  );
};

export default TrainingForm;
